window.jQuery = window.$ = require("jQuery");
jQuery(function($){
  let DEV = true;
  let __console__ = function(a){
    if(DEV){
      console.log(a);
    }
  };
  let _$window = $(window);
  let _$html = $("html");
  let _$header = $("header");

  let _isSP;
  let _ua = window.navigator.userAgent.toLowerCase();
  if(
      (_ua.indexOf("windows") !== -1 && _ua.indexOf("phone") !== -1) ||
      _ua.indexOf("iphone") !== -1 ||
      _ua.indexOf("ipod") !== -1 ||
      (_ua.indexOf("android") !== -1 && _ua.indexOf("mobile") !== -1) ||
      (_ua.indexOf("firefox") !== -1 && _ua.indexOf("mobile") !== -1) ||
      _ua.indexOf("blackberry") !== -1
  ){
    _isSP = true;
  }
  else{
    _isSP = false;
  }

  let __tag;
  if(window.location.pathname.indexOf("1710_a") > -1){
    __tag = "idx_1911";
  }else if( window.location.pathname.indexOf("/anshinpad/b/") > -1 || window.location.pathname.indexOf("1710_b") > -1){
    __tag = "idx_1911_B";
  }else{
    __tag = "idx_1911";
  }


  let _$headerNavi = $("#header_navi");
  let _$naviBtn = $("#navi_menu");

  let _naviOpenClose = function(){
    if(_$headerNavi.hasClass("header-navi-open")){
      _$headerNavi.removeClass("header-navi-open")
    }else{
      _$headerNavi.addClass("header-navi-open")
    }
  };

  _$naviBtn.on("click", _naviOpenClose);

  let _$qaBox = $(".qa-box");
  let _qaFunc = function(event){
    __num = event.data.num
    __$qaBox = $(_$qaBox[__num]);
    __$qaQ = __$qaBox.find(".qa-q");
    __$qaA = __$qaBox.find(".qa-a");

    __$close =__$qaQ.find(".a-close");
    __$open = __$qaQ.find(".a-open");

    if( __$open.css("display") === "none"){
      __$qaQ.removeClass("qa-q-open");
      __$close.css({display : "none"});
      __$open.css({display : "block"});
    } else {
      __$qaQ.addClass("qa-q-open");
      __$close.css({display : "block"});
      __$open.css({display : "none"});

      if(__$qaQ.hasClass("qa-q2")){
        gtag('event', 'question', {'event_label': __tag + '_btn-Q_2'});
        __console__(__tag + '_btn-Q_2');
      }else if(__$qaQ.hasClass("qa-q3")){
        gtag('event', 'question', {'event_label' : __tag + '_btn-Q_3'});
        __console__(__tag + '_btn-Q_3');
      }else if(__$qaQ.hasClass("qa-q4")){
        gtag('event', 'question', {'event_label' : __tag + '_btn-Q_4'});
        __console__(__tag + '_btn-Q_4');
      }else if(__$qaQ.hasClass("qa-q5")){
        gtag('event', 'question', {'event_label' : __tag + '_btn-Q_5'});
        __console__(__tag + '_btn-Q_5');
      }else if(__$qaQ.hasClass("qa-q6")){
        gtag('event', 'question', {'event_label' : __tag + '_btn-Q_6'});
        __console__(__tag + '_btn-Q_6');
      }else if(__$qaQ.hasClass("qa-q7")){
        gtag('event', 'question', {'event_label' : __tag + '_btn-Q_7'});
        __console__(__tag + '_btn-Q_7');
      }else if(__$qaQ.hasClass("qa-q8")){
        gtag('event', 'question', {'event_label' : __tag + '_btn-Q_8'});
        __console__(__tag + '_btn-Q_8');
      }else{
        gtag('event', 'question', {'event_label' : __tag + '_btn-Q_1'});
        __console__(__tag + '_btn-Q_1');
      }
    }
    __$qaA.stop().slideToggle();
  };

  _$qaBox.each(
    function(i){
      __$qaQ = $(this).find(".qa-q");
      __$qaQ.on("click", {num : i}, _qaFunc);
    }
  );

  let _s = $("#scene_wrap").slick({
    dots: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [{
      breakpoint: 750,
      settings: {
        centerMode: true,
        centerPadding: "14%",
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });

  let _mvs = $("#movie_slider");
  _mvs.slick({
    dots: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [{
      breakpoint: 750,
      settings: {
        centerMode: true,
        centerPadding: "4%",
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  let _ChangeMvs = function(){
    if (_$window.width() === 750) {
      _mvs.slick('setPosition');
    } else if (_$window.width() === 751)  {
      _mvs.slick('setPosition');
    }
  };
  _$window.on("resize", _ChangeMvs);

  let _shindan1 = document.getElementById("shindan1");
  let _shindan2 = document.getElementById("shindan2");

  let _btnDoShindan = $("#shindan_btn1");
  let _btnREShindan = $("#shindan_btn2");

  let _results = $(".result");
  let _shindanNotice = $("#shindan_notice");


  let _ChangeSelect = function(){
    if(_shindan1.selectedIndex === 0 || _shindan2.selectedIndex === 0){
      return
    }else{
      _btnDoShindan.removeClass("shindan-btn1-disabled");
    }
  };


  let _Shindan = function(){
    if( _btnDoShindan.hasClass("shindan-btn1-disabled")){
      return false;
    }else{
      _btnDoShindan.css({display:"none"});
      _btnREShindan.css({display:"block"});
      _shindanNotice.css({display:"block"});

      _shindan1.setAttribute("disabled","disabled");
      _shindan2.setAttribute("disabled","disabled");

      __class = "result-" + _shindan1.options[_shindan1.selectedIndex].value + _shindan2.options[_shindan2.selectedIndex].value;

      _results.each(
          function(){
            let  __$that = $(this);
            __$that = $(this)
            if(__$that.hasClass(__class)){
              __$that.addClass("result-active");
            }else{
              __$that.removeClass("result-active");
            }
          }
      );
    }
  };

  let _REShindan = function(){
    _shindan1.selectedIndex = 0;
    _shindan2.selectedIndex = 0;
    _shindan1.removeAttribute("disabled");
    _shindan2.removeAttribute("disabled");
    _btnDoShindan.addClass("shindan-btn1-disabled").css({display:""});
    _btnREShindan.css({display:""});
    _shindanNotice.css({display:""});
    _results.each(
      function(){
        let __$that = $(this);
        if( __$that.hasClass("result-wait")){
          __$that.addClass("result-active");
        }else{
          __$that.removeClass("result-active");
        }
      });
  };

  _btnDoShindan.on("click", _Shindan);
  _btnREShindan.on("click", _REShindan);
  _shindan1.addEventListener("change", _ChangeSelect, false);
  _shindan2.addEventListener("change", _ChangeSelect, false);

  class _MovieModal{
    constructor(){
      this.overlay = $("#modal_overlay");
      this.container = $("#modal_container_movie");
      this.youtubewrap = $("#youtube").empty();
    }

    start(href){
      this.container.css({display:"block",opacity : 1, zIndex : 104, position: "fixed"});
      this.overlay.css({display:"block",opacity : 1, zIndex : 103});
      let _href = (href).toString().split("=")[1];
      let _youtube = '<iframe width="100%" height="388" src="https://www.youtube.com/embed/' + _href + '?rel=0&showinfo=0&autoplay=1" frameborder="0" allowfullscreen></iframe>';
      this.youtubewrap.append(_youtube);
      $("body").css({"overflow-x": "hidden", "overflow-y": "auto"});
      $("html").css({"overflow": "hidden"});
    }

    close(){
      this.container.css({display:"none",opacity : 0, zIndex : 0, position:""});
      this.overlay.css({display:"none",opacity : 0, zIndex : 0});
      this.youtubewrap.empty();
      $("body").css({"overflow-x": "", "overflow-y": ""});
      $("html").css({"overflow": ""});
    }
  }

  let _mm = new _MovieModal();
  let _movieBtn = $("#movie_btn").find("a");
  let _movieBtnSp = $("#movie_btn_sp").find("a");
  let _reasonBtnSp = $("#reason_btn").find("a");
  let _secretMovieBtn = $("#secret_movie_btn").find("a");
  _movieBtn.on("click",function(event){
    _mm.start($(event.currentTarget).attr("href"));
    gtag('event', 'movie', {'event_label' : __tag + '_movie_tvcm_1'});
    __console__(__tag + '_movie_tvcm_1');
    return false;
  });
  _movieBtnSp.on("click",function(event){
    _mm.start($(event.currentTarget).attr("href"));
    gtag('event', 'movie', {'event_label' : __tag + '_movie_tvcm_1'});
    __console__( __tag + '_movie_tvcm_1');
    return false;
  });

  _reasonBtnSp.on("click",function(event){
    _mm.start($(event.currentTarget).attr("href"));
    gtag('event', 'movie', {'event_label' : __tag + '_movie_reason'});
    __console__( __tag + '_movie_reason');
    return false;
  });

  _secretMovieBtn.on("click",function(event){
    _mm.start($(event.currentTarget).attr("href"));
    gtag('event', 'movie', {'event_label' : __tag + '_movie_2'});
    __console__( __tag + '_movie_2');
    return false;
  });

  let __tag_2008 = "idx_2008";
  $("#movie_slider").on("click", "a", function(event){
    _mm.start($(event.currentTarget).attr("href"));
    gtag('event', 'movie', {'event_label' : __tag_2008 + '_movie_tvcm_' + $(event.currentTarget).data("number")});
    __console__( __tag_2008 + '_movie_tvcm_' + $(event.currentTarget).data("number"));
    return false;
  });


  $("#modal_overlay").on("click", $.proxy(_mm.close, _mm));
  $("#modal_container_movie").find(".modal-close").on("click",  $.proxy(_mm.close, _mm));
  $('a[href^="#"],area[href^="#"]').on(
    "click",
    function(){
      let _this = $(this);
      if(_this.attr('href') === '#' || _this.attr('href') === undefined){
        return false;
      }
      let spd = 500;
      let hr = _this.attr('href');
      let target = $(hr || '#header');
      let pos = target.offset().top - _$header.height();
      $('html, body').animate({scrollTop :pos}, spd);
      if(_$headerNavi.hasClass("header-navi-open")){
        _$headerNavi.removeClass("header-navi-open")
      }
      return false
    });


});